import { render, staticRenderFns } from "./EditorGroupTabs.vue?vue&type=template&id=264316f1&"
import script from "./EditorGroupTabs.vue?vue&type=script&lang=js&"
export * from "./EditorGroupTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports